import { render, staticRenderFns } from "./TableCareList.vue?vue&type=template&id=b7a6879e&scoped=true"
import script from "./TableCareList.vue?vue&type=script&lang=js"
export * from "./TableCareList.vue?vue&type=script&lang=js"
import style0 from "./TableCareList.vue?vue&type=style&index=0&id=b7a6879e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a6879e",
  null
  
)

export default component.exports